import { render, staticRenderFns } from "./CadastroUsuario.vue?vue&type=template&id=165bb22e"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports